import AuthService from '../services/AuthService'

function login(username, password){
    return dispatch => {
        // dispatch(request({username}));
        AuthService.login(username, password)
        .then(
            user => {
                console.log(user);
                dispatch(success(user));
            //history.push('/');
            },
            error => {
                dispatch(failure(error));                
            }
        )
    };
    // function request(user) { return {type: "LOGIN_REQUEST", user}}
    function success(user) { return {type: "LOGIN_SUCCESS", payload: user}}
    function failure(user) { return {type: "LOGIN_FAIL", payload: user}}
}
function memLogin(memNo, password){
    return dispatch => {
        // dispatch(request({username}));
        AuthService.memLogin(memNo, password)
        .then(
            users => {
                console.log(users);
                dispatch(success(users));
            //history.push('/');
            },
            error => {
                // console.log(typeof(error),"ll")
                // console.log(error["Error"])
                dispatch(failure(error));                
            }
        )
    };
    // function request(user) { return {type: "LOGIN_REQUEST", user}}
    function success(users) { return {type: "LOGIN_SUCCESS", payload: users}}
    function failure(users) { return {type: "LOGIN_FAIL", payload: users}}
}

function logout() {
    AuthService.logout();
    console.log("Run");
    return { type: "LOGOUT" };
}

export const userActions = { login, logout ,memLogin}


